module.exports = __webpack_public_path__ + "static/default-image-47b9ceb90faf1f8e19d047fc31cd9a77.png";